<div class="modal">
  <div class="main">
    <div class="content">
      @if (config.showHeader) {
        <h2>{{config.header}}</h2>
      }
      <br>
        <h3>{{config.message}}</h3>

        <div class="buttons">
          @if (config.showAcceptButton) {
            <p class="jeopardy-button primary">
              <a href="#" (click)="close($event, true)">{{config.acceptButtonLabel}}</a>
            </p>
          }
          @if (config.showCancelButton) {
            <p class="jeopardy-button secondary">
              <a href="#" (click)="close($event, false)">{{config.cancelButtonLabel}}</a>
            </p>
          }
        </div>
      </div>
    </div>
  </div>
